import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { AvatarModule } from '@nano/common/avatar';
import { FileUploadModule } from '@nano/common/file';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzListModule } from 'ng-zorro-antd/list';

import { SendMessageModule } from '../shared/send-message/send-message.module';
import { MessageThreadDetailsComponent } from './message-thread-details.component';

@NgModule({
  declarations: [MessageThreadDetailsComponent],
  imports: [CommonModule, AvatarModule, FileUploadModule, NzGridModule, NzListModule, SendMessageModule],
  exports: [MessageThreadDetailsComponent]
})
export class MessageThreadDetailsModule {}
